import { Button } from "primereact/button"
import { Calendar } from "primereact/calendar"
import { Dropdown } from "primereact/dropdown"
import { useEffect } from "react"
import { useExcelExport } from "../../../../utilidades/customHooks/useExcelExport"

const Filtros = ({ filtros, setFiltros, operadores, setDatos,datos, setIndicadores, buscar }) => {
    const {exportarAExcel} = useExcelExport()
    const limpiar = () => {
        setFiltros({ operador: null, desde: new Date(), hasta: new Date() });
        setDatos(null);
        setIndicadores(null);
    };
    const exportarTodoCSV = () => {
        const columnas = [
            { field: 'OPERADOR', header: 'OPERADOR' },
            { field: 'BONO_DOMINGOS_EMPRESARIAL', header: 'BONO_DOMINGOS_EMPRESARIAL' },
            { field: 'DIAS', header: 'DIAS' },
            { field: 'DIAS_TRABAJADOS', header: 'DIAS_TRABAJADOS' },
            { field: 'DIAS_TOTALES', header: 'DIAS_TOTALES' },
            { field: 'ID_CHOFER', header: 'ID_CHOFER' },
            { field: 'KILOMETROS_UNITARIOS', header: 'KILOMETROS_UNITARIOS' },
            { field: 'NUMERO_VIAJE', header: 'NUMERO_VIAJE' },
            { field: 'PAGO_DOMINGO_EMPRESARIAL', header: 'PAGO_DOMINGO_EMPRESARIAL' },
            { field: 'PAGO_TOTAL_CHOFER', header: 'PAGO_TOTAL_CHOFER' },
            { field: 'PAGO_UNITARIO_CHOFER', header: 'PAGO_UNITARIO_CHOFER' },
            { field: 'RUTA', header: 'RUTA' },
            { field: 'SUELDO_GARANTIA', header: 'SUELDO_GARANTIA' },
            { field: 'TIPO', header: 'TIPO' },
            { field: 'TIPO_SERVICIO', header: 'TIPO_SERVICIO' },
            { field: 'TOTAL_BITACORAS_CHOFER', header: 'TOTAL_BITACORAS_CHOFER' },
            { field: 'TOTAL_EMPRESARIALES', header: 'TOTAL_EMPRESARIALES' },
            { field: 'TOTAL_EMPRESARIALES_DOMINGO', header: 'TOTAL_EMPRESARIALES_DOMINGO' },
            { field: 'TOTAL_ESPECIALES', header: 'TOTAL_ESPECIALES' },
            { field: 'TOTAL_KILOMETROS', header: 'TOTAL_KILOMETROS' },
            { field: 'TOTAL_VISITAS_TALLER', header: 'TOTAL_VISITAS_TALLER' },
            { field: 'TRABAJA_DOMINGOS', header: 'TRABAJA_DOMINGOS' },
            { field: 'UNIDAD_TIPO', header: 'UNIDAD_TIPO' },
        ]
        exportarAExcel(datos, columnas, "REPORTE_PAGO_OPERADOR")
    };
    return (
        <div className="filtros">
            <div className="grupo-filtro">
                <label>Operador</label>
                <Dropdown
                    value={filtros.operador}
                    onChange={(e) => setFiltros({ ...filtros, operador: e.value })}
                    options={operadores}
                    placeholder="Seleccione un operador"
                    className="w-full"
                    filter
                    optionLabel="name"
                />
            </div>
            <div className="grupo-filtro">
                <label>Desde</label>
                <Calendar
                    value={filtros.desde}
                    onChange={(e) => setFiltros({ ...filtros, desde: e.value })}
                    showIcon
                    dateFormat="dd/mm/yy"
                    className="w-full"
                />
            </div>
            <div className="grupo-filtro">
                <label>Hasta</label>
                <Calendar
                    value={filtros.hasta}
                    onChange={(e) => setFiltros({ ...filtros, hasta: e.value })}
                    showIcon
                    dateFormat="dd/mm/yy"
                    className="w-full"
                />
            </div>
            <div className="grupo-botones">
                <Button
                    icon="pi pi-search"
                    label="Buscar"
                    onClick={() => { buscar() }}
                />
                <Button
                    icon="pi pi-times"
                    label="Limpiar"
                    severity="secondary"
                    onClick={limpiar}
                />
                <Button
                    icon="pi pi-download"
                    label="Descargar Reporte"
                    severity="success"
                    onClick={()=>{exportarTodoCSV()}}
                />
            </div>
        </div>
    )

}
export default Filtros